class TabsPills {
  constructor () {
    this.init()
  }

  init () {
    document.addEventListener('DOMContentLoaded', () => {
      this.loadTab()
      this.setActive()
    })
  }

  loadTab () {
    const tabsBtn = document.querySelector('.js-tabs-pills .js-tabs-pills-btn')
    if(tabsBtn) {
      document.querySelector('.js-tabs-pills .js-tabs-pills-btn').classList.add('active');
      document.querySelector('.js-tabs-pills .js-tabs-icons-content').classList.remove('hidden')
    }
  }
  setActive () {
    const pillsButton = document.querySelectorAll('.js-tabs-pills-btn')
    pillsButton.forEach(pill => {
      pill.addEventListener('click', (event) => {
        this.setClassActiveTab(pill)
        this.setClassActiveBtn(pill)
      })
    })
  }

  setClassActiveTab (pill) {
    const prevTab = document.querySelector('.js-tabs-icons-content:not(.hidden)')
    const categorySlug = pill.dataset.id
    const tabContent = document.querySelector(`.js-tabs-icons-content[data-tab-content='${categorySlug}']`)
    if (prevTab.dataset.tabContent == categorySlug) return
    if (prevTab) {
      prevTab.classList.add('hidden')
    }
    tabContent.classList.remove('hidden')
  }

  closeTabContent() {
    const tabs= document.querySelectorAll('.js-tabs-icons-content')
    tabs.forEach((tab, key) => {
      if(key == 0) return
      tab.classList.add('hidden')
    })
  }
  setClassActiveBtn (btn) {
    btn.closest('.js-tabs-pills').querySelector('.js-tabs-pills-btn.active').classList.remove('active')
    btn.classList.add('active')
  }
}
window.tabsPills = new TabsPills()
